<template>
  <div>
    <!--Map Section Start-->
    <section class="p-0">
      <div class="container-fluid">
        <div class="bottom-section">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="address-bar">
                <div>
                  <ul class="footer-style">
                    <li>
                      <div class="footer-icon">
                        <img
                          src="../assets/images/locate.png"
                          alt="locate"
                        >
                      </div>
                      <div class="footer-address">
                        <a href="#">595 Burrard St, Vancouver, BC V7X 1L4</a>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img
                          src="../assets/images/telephone.png"
                          alt="telephone"
                        >
                      </div>
                      <div class="footer-address">
                        <a href="tel:+16042456680">(604) 245-6680</a>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img
                          src="../assets/images/fotter-email.png"
                          alt="fotter-email"
                        >
                      </div>
                      <div class="footer-address">
                        <a href="mailto:info@ezfixd.com">info@mechaniclick.com</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 p-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2318.5348910139664!2d-123.121036904832!3d49.28648737021602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486718227ddb347%3A0x9f24e2c2faae0a85!2s595%20Burrard%20St%2C%20Vancouver%2C%20BC%20V7X%201L7!5e0!3m2!1sen!2sca!4v1573814283687!5m2!1sen!2sca"
                class="md-height"
              />
              <!-- <iframe :src='"https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d35391.48685150366!2d72.77537852898678!3d21.18930639680146!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1530610361925"'  class="md-height"></iframe>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Map Section Ends-->
  </div>
</template>
<script>
export default {
  name: 'Map',
}
</script>



// WEBPACK FOOTER //
// src/components/map.vue